/*
 * @Author:chenxf
 * @Date: 2017-12-20 14:45:10
 * @Description: website网站管理
 * @Last Modified by: 东隅
 * @Last Modified time: 2020-05-21 19:31:29
 */

import api from '@/api/index'

const state = {
  riskTranscationList: {
    total: 0,
    records: []
  }
}

const mutations = {
  getRiskTranscationList(state, data) {
    state.riskTranscationList = _.cloneDeep(data)
  }
}

const actions = {
  getRiskTranscationList: async({
    commit,
    state
  }, param) => {
    const data = await api.getRiskTranscationList(param)
    console.log('data0000----------', data)
    if (data) {
      commit('getRiskTranscationList', data)
    }
  }

}
const getters = {
  riskTranscationList: state => state.riskTranscationList
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
